<template>
  <div class="contents">
      <div class="function">
        <div class="title">更多功能</div>
        <div class="write">
            更多实用功能，等待您的体验
        </div>
        <div class="port">
           <Four></Four>
        </div>
    </div>
  </div>
</template>
<script>
import Four from '../Four'

export default {
  name:'function',
  components:{Four}
}
</script>

<style scoped>
.contents{
    width:100%;
    /* height: 100%; */
    height: 1142px;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.function{
    display: flex;
    align-items: center;
    flex-direction: column;
}
.title{
    font-family: 微软雅黑;
font-size: 50px;
line-height: 0px;
letter-spacing: 5px;
height: 50px;
line-height: 50px;
margin-top:100px;
color: #333333;
}
.write{
height: 66px;
font-family: 微软雅黑;
font-size: 24px;
letter-spacing: 1px;
color: #999999;
margin-top:50px;
text-align: center;
}
.port{
       margin-top: 96px;
       margin-bottom: 50px;
}


</style>




// WEBPACK FOOTER //
// src/components/software/function.vue